<template>
  <el-container id="root_container" style="padding: 0px;margin: 0px; overflow: hidden;">

    <el-header class="headerManu">
      <div style="height: 60px;background-color: transparent;float: left; margin-left: 20px; display: flex;flex-direction: row;justify-content: start;">
        <img  :src="logo"  style="float: left;width: 50px;height: 50px;margin-top: 5px;"/>
        <div style="background-color: transparent; color: white; height: 60px; display: flex;flex-direction: column;justify-content: start; padding-left: 10px;">
          <div style="margin-top: 5px;height: 30px;line-height: 30px;font-size: 18px; text-align: left; font-family: 'Courier New'">全国主粮作物减产风险与</div>
          <div style="height: 20px;line-height: 20px;font-size: 18px;text-align: left; font-family: 'Courier New'">保险费率地图</div>
        </div>
      </div>
    </el-header>


    <el-main id="router_view">
      <el-row>
        <!--左侧菜单-->
        <el-col  id="menu_container" :span="menuSpan">
          <ih-signal-vertical-tabs :mTabs="mTabs" @tabChanged="menuClicked" v-show="(activeIndex =='env' ||activeIndex =='pop'  )"></ih-signal-vertical-tabs>
          <el-menu
            ref="el_menu_risk"
            style="width: 100%;"
            id="ChangeRisksMenus"
            v-show="activeIndex=='risk'"
            default-active="rice_100"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose">
            <el-submenu index="cropRisk_RICE" class="menuGroup_title">
              <template slot="title" style="background-color: #ff0000;"><span class="GS_menuItem">水稻</span></template>
              <el-menu-item index="rice_100" @click="foldMenuClick"><span class="subMenu">100%保障水平</span></el-menu-item>
              <el-menu-item index="rice_90" @click="foldMenuClick"><span class="subMenu">90%保障水平</span></el-menu-item>
              <el-menu-item index="rice_80" @click="foldMenuClick"><span class="subMenu">80%保障水平</span></el-menu-item>
              <el-menu-item index="rice_70" @click="foldMenuClick"><span class="subMenu">70%保障水平</span></el-menu-item>
            </el-submenu>
            <el-submenu index="cropRisk_WHEAT" class="menuGroup_title">
              <template slot="title" style="background-color: red;"><span class="GS_menuItem">小麦</span></template>
              <el-menu-item index="wheat_100" @click="foldMenuClick"><span class="subMenu">100%保障水平</span></el-menu-item>
              <el-menu-item index="wheat_90" @click="foldMenuClick"><span class="subMenu">90%保障水平</span></el-menu-item>
              <el-menu-item index="wheat_80" @click="foldMenuClick"><span class="subMenu">80%保障水平</span></el-menu-item>
              <el-menu-item index="wheat_70" @click="foldMenuClick"><span class="subMenu">70%保障水平</span></el-menu-item>
            </el-submenu>
            <el-submenu index="cropRisk_MAIZE" class="menuGroup_title">
              <template slot="title" style="background-color: red;"><span class="GS_menuItem">玉米</span></template>
              <el-menu-item index="maize_100" @click="foldMenuClick"><span class="subMenu">100%保障水平</span></el-menu-item>
              <el-menu-item index="maize_90" @click="foldMenuClick"><span class="subMenu">90%保障水平</span></el-menu-item>
              <el-menu-item index="maize_80" @click="foldMenuClick"><span class="subMenu">80%保障水平</span></el-menu-item>
              <el-menu-item index="maize_70" @click="foldMenuClick"><span class="subMenu">70%保障水平</span></el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>

        <!--地图容器-->
        <el-col :span="mapSpan" style="position: relative">

          <!-- Map container-->
          <div id="map" style="width: auto; z-index: 1"></div>
          <div  id="mapResizeButton" style="background-color: rgb(67,133,185); width: 27px; height: 65px;padding: 2px;border-radius: 3px; border: 3px solid rgb(135,206,235)">
            <img :src="menuresizeicon_description" style="width: 100%; color: white;margin-top: 5px; margin-bottom: 5px; width: 22px;height: 22px;" @click="openDescriptionDlg"/>
            <img :src="menuResizeIcon" style="width: 100%; color: white;width: 25px;height: 25px;" @click="mapResize"/>
          </div>

<!--          &lt;!&ndash;图例&ndash;&gt;-->
<!--          <map-lengend-->
<!--            :title="legendTitle"-->
<!--            ref="ref_mapLegend"-->
<!--            @colorsChanged="colorsChanged"-->
<!--            :legends="selectedMapLegendsStyle"-->
<!--            class="legend"-->
<!--            id="IDLegend"-->
<!--            @layoutupdate="legend_layoutupdate"-->
<!--            style="display: none;"></map-lengend>-->

          <!--Radio Group-->
          <div  class="radio_group">

            <!-- 纯风险损失率/风险费率-->
            <el-radio-group v-model="radioG_cc_prcptot_mm" class="item_more" @change="radioGroup_change"  v-show="MMESVisible" style="margin-left: 10px;">
              <el-radio label="fxfl">风险费率</el-radio>
              <el-radio label="cfxssl">纯风险损失率</el-radio>
            </el-radio-group>

            <!--栅格 & 县级 & 地市-->
            <el-radio-group v-model="radioG_cc_prcptot" v-show="radioG_cc_prcptot_mm=='cfxssl'?true:false" class="item_one" @change="radioGroup_change" style="margin-left: 15px;">
              <el-radio :label="item.radio_code"  v-for="item in radioData">{{item.radio_title}}</el-radio>
            </el-radio-group>

            <el-radio-group v-model="radioG_10_20" class="item_more" @change="radioGroup_change" style="margin-left: 15px;" v-show="radioG_cc_prcptot_mm == 'fxfl'">
              <el-radio label="10">10年一遇</el-radio>
              <el-radio label="20">20年一遇</el-radio>
            </el-radio-group>

          </div>

          <!-- overlay -->
          <div id="popup" class="ol-popup">
            <el-row style="background-color: transparent; line-height: 20px; height: 20px;">
              <el-col :span=20 style="text-align: left;"><div style="padding-right: 20px;">
                {{ parseFloat(selectedRasterMapData * 100).toFixed(2)}}%</div></el-col>
              <el-col :span=4 style="text-align: right;">
                <a href="#" id="popup-closer" class="ol-popup-closer" style="font-size: 17px;"></a>
              </el-col>
            </el-row>
          </div>

        </el-col>

      </el-row>
    </el-main>


    <el-dialog :visible.sync="descriptionDlgVisible" top="7vh" width="65vw" height="78vh" :before-close="closeDescriptionDlg">
      <div style="text-align: left;margin-top: -50px; font-size: 1.5em;" v-html="html_desc"></div>
    </el-dialog>



    <div id="mapLegends"
         v-show="legends.length>0"
         style="position: absolute; right: 0px; bottom: 0px; border-radius: 3px;
    padding: 10px;
    width: 200px; height: 300px; z-index: 100;background-color: white;border: solid 1px lightgrey;">
      <el-col>
        <el-row style="text-align: left;margin-bottom: 5px;font-weight: bold;font-size: 14px;">图例</el-row>
        <el-row v-for="item in legends">
          <el-col :span="24" class="cell_col_0" style="display: flex;flex-direction: row; background-color: transparent; overflow: hidden;">
            <div class="cell_tile"  :style="{backgroundColor:item.color}"></div>
            <sapan style="margin-left: 10px;"> {{item.label}}</sapan>
          </el-col>
        </el-row>
      </el-col>
    </div>


  </el-container>
</template>

<script>

  import  mapLengend from "@/view/BSD/components/CropsRisMapLengend";

  import 'ol/ol.css'
  import Overlay from 'ol/Overlay';
  import {toSize} from 'ol/size';
  import {menus_env,menus_risk, Risk_radioGroupData} from "./BSDConfig"
  import {TDM_LAYER_CVA_C,TDM_LAYER_IBO_C,TDM_LAYER_EVA_C} from "../../components/map/common/constant"

  import pdf from "vue-pdf";
  import CMapReaderFactory from "vue-pdf/src/CMapReaderFactory.js";
  let geojsonData_China = require("./china");
  let geojsonData = require("./jiuduan.json");
  let countriesgeo = require("./countriesgeo");
  // let GJ_Henan = require('./GJ_Henan.json');
  // let GJ_Hebei = require('./province/河北省.json');
  // let GJ_Shangdong = require('./province/山东省.json');
  // let GJ_Xinjiang = require('./province/新疆维吾尔自治区.json');
  // let neimengdu = require('./province/内蒙古自治区.json');
  // let beijingshi = require('./province/北京市.json');
  // let jilinsheng = require('./province/吉林省.json');
  // let sichuansheng = require('./province/四川省.json');
  // let tianjinshi = require('./province/天津市.json');
  // let anhui = require('./province/安徽省.json');
  // let guangdong = require('./province/广东省.json');
  // let guangxi = require('./province/广西壮族自治区.json');
  // let liaoning = require('./province/辽宁省.json');
  // let helongjiang = require('./province/黑龙江省.json');
  //
  // let xizang = require('./province/西藏自治区.json');
  // let qinghai = require('./province/青海省.json');
  // let shanxi = require('./province/山西省.json');
  // let shanxii = require('./province/陕西省.json');
  // let gansu = require('./province/甘肃省.json');
  // let ningxia = require('./province/宁夏回族自治区.json');
  // let hubei = require('./province/湖北省.json');
  // let hunan = require('./province/湖南省.json');
  // let chongqing = require('./province/重庆市.json');
  // let guizhou = require('./province/贵州省.json');
  // let jiangxi = require('./province/江西省.json');
  // let zhejiang = require('./province/浙江省.json');
  // let jiangsu = require('./province/江苏省.json');
  // let yunan = require('./province/云南省.json');
  // let fujian = require('./province/福建省.json');
  // let shanghai = require('./province/上海市.json');


  import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
  import { TileWMS, OSM, Vector as VectorSource } from "ol/source";
  import GeoJSON from "ol/format/GeoJSON";
  import {Circle as CircleStyle, Stroke, Style} from 'ol/style'
  import Fill from 'ol/style/Fill'

  //Init Icon Params
  let menuresizeicon_min =  require( '../../assets/icons/menu_shousuo_w.png');
  let menuresizeicon_max =  require( '../../assets/icons/menu_zhankai_w.png');
  let menuresizeicon_description =  require( '../../assets/icons/description.png');
  let icon_legend_zhankai =  require( '../../assets/icons/icon_zhankai.png');
  let icon_zhankai_w =  require( '../../assets/icons/icon_zhankai_w.png');
  let icon_shousuo_w =  require( '../../assets/icons/icon_shousuo_w.png');
  let bsd_logo =  require( '../../../src/assets/icons/earth.png');
  let file_download =  require( '../../assets/icons/download.png');
  let file_detail =  require( '../../assets/icons/查看详情.png');
  let bunMenuIcon =  require( '../../assets/imgs/bunMenu.png');
  let catastrophic_maize = require("../../../static/bunSld_cropRisks/catastrophic_maize.json");
  let catastrophic_rice = require("../../../static/bunSld_cropRisks/catastrophic_rice.json");
  let catastrophic_wheat = require("../../../static/bunSld_cropRisks/catastrophic_wheat.json");


  //
  import BSDConfigLegendTitle from "./BSDConfigLegendTitle_Risk"
  import {getCenter} from "ol/extent";

  //county
  let county_maize_wheat_rice_mme_1981_2016_lcr_100_maize = require('../../../static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_100_maize.json');
  let county_maize_wheat_rice_mme_1981_2016_lcr_100_rice = require('../../../static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_100_rice.json');
  let county_maize_wheat_rice_mme_1981_2016_lcr_100_wheat = require('../../../static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_100_wheat.json');
  let county_maize_wheat_rice_mme_1981_2016_lcr_90_maize = require('../../../static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_90_maize.json');
  let county_maize_wheat_rice_mme_1981_2016_lcr_90_rice = require('../../../static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_90_rice.json');
  let county_maize_wheat_rice_mme_1981_2016_lcr_90_wheat = require('../../../static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_90_wheat.json');
  let county_maize_wheat_rice_mme_1981_2016_lcr_80_maize = require('../../../static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_80_maize.json');
  let county_maize_wheat_rice_mme_1981_2016_lcr_80_rice = require('../../../static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_80_rice.json');
  let county_maize_wheat_rice_mme_1981_2016_lcr_80_wheat = require('../../../static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_80_wheat.json');
  let county_maize_wheat_rice_mme_1981_2016_lcr_70_maize = require('../../../static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_70_maize.json');
  let county_maize_wheat_rice_mme_1981_2016_lcr_70_rice = require('../../../static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_70_rice.json');
  let county_maize_wheat_rice_mme_1981_2016_lcr_70_wheat = require('../../../static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_70_wheat.json');
  //city
  let city_mme_1981_2016_lcr_100_maize = require('../../../static/bunSld_cropRisks/city_mme_1981_2016_lcr_100_maize.json');
  let city_mme_1981_2016_lcr_100_wheat = require('../../../static/bunSld_cropRisks/city_mme_1981_2016_lcr_100_wheat.json');
  let city_mme_1981_2016_lcr_100_rice = require('../../../static/bunSld_cropRisks/city_mme_1981_2016_lcr_100_rice.json');
  let city_mme_1981_2016_lcr_90_maize = require('../../../static/bunSld_cropRisks/city_mme_1981_2016_lcr_90_maize.json');
  let city_mme_1981_2016_lcr_90_wheat = require('../../../static/bunSld_cropRisks/city_mme_1981_2016_lcr_90_wheat.json');
  let city_mme_1981_2016_lcr_90_rice = require('../../../static/bunSld_cropRisks/city_mme_1981_2016_lcr_90_rice.json');
  let city_mme_1981_2016_lcr_80_maize = require('../../../static/bunSld_cropRisks/city_mme_1981_2016_lcr_80_maize.json');
  let city_mme_1981_2016_lcr_80_wheat = require('../../../static/bunSld_cropRisks/city_mme_1981_2016_lcr_80_wheat.json');
  let city_mme_1981_2016_lcr_80_rice = require('../../../static/bunSld_cropRisks/city_mme_1981_2016_lcr_80_rice.json');
  let city_mme_1981_2016_lcr_70_maize = require('../../../static/bunSld_cropRisks/city_mme_1981_2016_lcr_70_maize.json');
  let city_mme_1981_2016_lcr_70_wheat = require('../../../static/bunSld_cropRisks/city_mme_1981_2016_lcr_70_wheat.json');
  let city_mme_1981_2016_lcr_70_rice = require('../../../static/bunSld_cropRisks/city_mme_1981_2016_lcr_70_rice.json');
  //cfxssl_raster
  let maize_MME_1981_2016_lcr_100 = require('../../../static/bunSld_cropRisks/cfxssl_raster/maize_MME_1981_2016_lcr_100.json');
  let maize_MME_1981_2016_lcr_90 = require('../../../static/bunSld_cropRisks/cfxssl_raster/maize_MME_1981_2016_lcr_90.json');
  let maize_MME_1981_2016_lcr_80 = require('../../../static/bunSld_cropRisks/cfxssl_raster/maize_MME_1981_2016_lcr_80.json');
  let maize_MME_1981_2016_lcr_70 = require('../../../static/bunSld_cropRisks/cfxssl_raster/maize_MME_1981_2016_lcr_70.json');
  let rice_MME_1981_2016_lcr_100 = require('../../../static/bunSld_cropRisks/cfxssl_raster/rice_MME_1981_2016_lcr_100.json');
  let rice_MME_1981_2016_lcr_90 = require('../../../static/bunSld_cropRisks/cfxssl_raster/rice_MME_1981_2016_lcr_90.json');
  let rice_MME_1981_2016_lcr_80 = require('../../../static/bunSld_cropRisks/cfxssl_raster/rice_MME_1981_2016_lcr_80.json');
  let rice_MME_1981_2016_lcr_70 = require('../../../static/bunSld_cropRisks/cfxssl_raster/rice_MME_1981_2016_lcr_70.json');
  let wheat_MME_1981_2016_lcr_100 = require('../../../static/bunSld_cropRisks/cfxssl_raster/wheat_MME_1981_2016_lcr_100.json');
  let wheat_MME_1981_2016_lcr_90 = require('../../../static/bunSld_cropRisks/cfxssl_raster/wheat_MME_1981_2016_lcr_90.json');
  let wheat_MME_1981_2016_lcr_80 = require('../../../static/bunSld_cropRisks/cfxssl_raster/wheat_MME_1981_2016_lcr_80.json');
  let wheat_MME_1981_2016_lcr_70 = require('../../../static/bunSld_cropRisks/cfxssl_raster/wheat_MME_1981_2016_lcr_70.json');

  //fxfl_raster catastrophic risk premium rate
  let maize_MME_1981_2016_lcr_70_return_10 = require('../../../static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_70_return_10.json');
  let maize_MME_1981_2016_lcr_70_return_20 = require('../../../static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_70_return_20.json');
  let maize_MME_1981_2016_lcr_80_return_10 = require('../../../static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_80_return_10.json');
  let maize_MME_1981_2016_lcr_80_return_20 = require('../../../static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_80_return_20.json');
  let maize_MME_1981_2016_lcr_90_return_10 = require('../../../static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_90_return_10.json');
  let maize_MME_1981_2016_lcr_90_return_20 = require('../../../static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_90_return_20.json');
  let maize_MME_1981_2016_lcr_100_return_10 = require('../../../static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_100_return_10.json');
  let maize_MME_1981_2016_lcr_100_return_20 = require('../../../static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_100_return_20.json');
  let rice_MME_1981_2016_lcr_70_return_10 = require('../../../static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_70_return_10.json');
  let rice_MME_1981_2016_lcr_70_return_20 = require('../../../static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_70_return_20.json');
  let rice_MME_1981_2016_lcr_80_return_10 = require('../../../static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_80_return_10.json');
  let rice_MME_1981_2016_lcr_80_return_20 = require('../../../static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_80_return_20.json');
  let rice_MME_1981_2016_lcr_90_return_10 = require('../../../static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_90_return_10.json');
  let rice_MME_1981_2016_lcr_90_return_20 = require('../../../static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_90_return_20.json');
  let rice_MME_1981_2016_lcr_100_return_10 = require('../../../static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_100_return_10.json');
  let rice_MME_1981_2016_lcr_100_return_20 = require('../../../static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_100_return_20.json');
  let wheat_MME_1981_2016_lcr_70_return_10 = require('../../../static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_70_return_10.json');
  let wheat_MME_1981_2016_lcr_70_return_20 = require('../../../static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_70_return_20.json');
  let wheat_MME_1981_2016_lcr_80_return_10 = require('../../../static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_80_return_10.json');
  let wheat_MME_1981_2016_lcr_80_return_20 = require('../../../static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_80_return_20.json');
  let wheat_MME_1981_2016_lcr_90_return_10 = require('../../../static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_90_return_10.json');
  let wheat_MME_1981_2016_lcr_90_return_20 = require('../../../static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_90_return_20.json');
  let wheat_MME_1981_2016_lcr_100_return_10 = require('../../../static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_100_return_10.json');
  let wheat_MME_1981_2016_lcr_100_return_20 = require('../../../static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_100_return_20.json');


  export default {
    name: "BNUCropsRisk",
    components:{mapLengend,pdf},
    data(){
      return {
        descriptionDlgVisible:false,
        descriptionDlgHeight:800,
        activeIndex: 'risk',
        menuSpan:0,
        mapSpan:24,
        menu_width:null,
        content_height:null,
        menuResizeIcon: menuresizeicon_max,
        menuresizeicon_description,
        logo: bsd_logo,
        //菜单配置
        mTabs:menus_env,
        //地图相关的
        map:null,
        mapZoomLevel:undefined,
        mapboundaryLayer:undefined,
        vector_layer:null,
        geoserver:"/geo_bsd/geoserver/DZZH/wms",
        geoserver_local:"/geo_bsd/geoserver/bsd/wms",
        geoserver_local_tiff:"/geo_bsd/geoserver/BNU_TIF/wms",
        geoserver_basic:"/geo_bsd/geoserver/",
        //
        lastClicedMenuItem:"Heatwave",
        lastClicedMenuItemGroup:"cc_precipitation",
        mapUtils:null,
        //Radio Group Data
        radioData:[
          {radio_title:"栅格",radio_code:"raster"},{radio_title:"地市",radio_code:"city"},{radio_title:"县级",radio_code:"county"}
        ],
        radioData_visible:true,
        radioG_cc_prcptot:"raster",
        //Cascader
        default_activemenu_cc:'cc_tmean_mean',
        selected_cascader:["2000s_s0"],
        cascader_options:[{
          value: '2000s_s0',
          label: 'Baseline',
        },
          {
            value: '2030S',
            label: '2030S',
            children:[
              {value: '2030s_rcp26', label: 'RCP2.6'},
              {value: '2030s_rcp45', label: 'RCP4.5'},
              {value: '2030s_rcp85', label: 'RCP8.5'},
            ]
          },
          {
            value: '2050S',
            label: '2050S',
            children:[
              {value: '2050s_rcp26', label: 'RCP2.6'},
              {value: '2050s_rcp45', label: 'RCP4.5'},
              {value: '2050s_rcp85', label: 'RCP8.5'},
            ]
          }],
        radioG_cc_prcptot_type:"value",
        radioG_cc_prcptot_mm:"fxfl",
        selectedRasterMapSrouce:undefined,
        selectedRasterMapLayer:undefined,
        selectedRasterMapWS:undefined,
        //legend
        legendModel:0,
        icon_zhankai_w,
        icon_shousuo_w,
        file_download,file_detail,
        //overlay
        defaultMapOverlay:undefined,
        selectedRasterMapData:undefined,
        //selected Map legends
        selectedMapLegendsStyle:undefined,
        loginUser:undefined,

        //pdf
        dialogVisible:false,
        pageCount: 0, //总页码
        pdfUrl: "",
        numPages: 0,
        loadedRatio: 0, //提示语

        //
        basicOceanLayer:undefined,
        MMESVisible:true,//特征值可见性控制
        bunMenuIcon,
        currentStyle:"",
        legendTitle:"Map Lengend",
        tableData:[],
        radioG_10_20:'10',
        html_desc:"<p>\n" +
          "\t<br />\n" +
          "</p>\n" +
          "<p class=\"MsoNormal\" style=\"text-indent:21.0pt;\">\n" +
          "\t本数据集是由北京师范大学地理科学学部灾害风险科学研究院农业保险研究团队，利用长时间序列县级历史单产数据，配合多作物模型集合模拟结果，在历史单产时空融合的基础上，模拟生成的全国水稻、小麦和玉米的农业保险费率厘定基本参数。本数据集充分利用了多源数据融合和多模型集合的方法，具有高空间分辨率、灵活性和可拓展性，可为农业保险行业的实践应用和可持续发展提供重要的技术方法和量化依据。\n" +
          "</p>\n" +
          "<p class=\"MsoNormal\" style=\"text-indent:21.0pt;\">\n" +
          "\t目前平台中显示的结果是2021年2月第一版本。平台中包含水稻、小麦、玉米三种作物，在10 km栅格、县、地市三种空间尺度，在70%、80%、90%和100%四种保障水平下的纯风险损失率，以及在<span class=\"15\">全国范围内统一分散大灾风险（全国范围使用相同的大灾风险附加费率）的前提下，</span><span class=\"15\">10</span><span class=\"15\">年一遇和</span><span class=\"15\">20</span><span class=\"15\">年一遇的风险费率（</span>风险费率＝纯风险损失率+大灾风险附加费率（表1）<span class=\"15\">）。总体而言，</span><span class=\"15\">70%</span><span class=\"15\">保障水平下，时空融合的结果对小空间尺度灾损的捕捉能力仍较为有限，费率略有低估。</span><span class=\"15\"></span> \n" +
          "</p>\n" +
          "<p class=\"MsoNormal\" align=\"center\" style=\"text-align:center;text-indent:0cm;\">\n" +
          "\t<span class=\"15\">表<span>1</span></span><span class=\"15\"> </span>四种保障水平下的10年一遇和20年一遇<span class=\"15\">全国大灾风险附加费率</span><span class=\"15\"></span> \n" +
          "</p>\n" +
          "<p class=\"MsoNormal\" align=\"center\" style=\"text-align:center;text-indent:0cm;\">\n" +
          "\t<span> </span> \n" +
          "</p>\n" +
          "<p class=\"MsoNormal\" align=\"center\" style=\"text-align:center;text-indent:0cm;\">\n" +
          // "\t<img src=\"scp -P22 -r dist root@47.114.180.160:/data/wwwroot/IHVUECompnentsLibrary\" alt=\"\" /> \n" +
          "</p>\n" +
          "<p class=\"MsoNormal\" style=\"text-indent:21.0pt;\">\n" +
          "\t<span><img style='width: 80%;margin-left: 7%;' src=\"http://47.104.62.144:9000/bun/additional/data_desc.png\" alt=\"\" /><br />\n \n" +
          "</span> <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;当前，数字地图可直接提供点击查询，下载功能因版权问题暂未提供开放。后续，研究团队将进一步融合多源数据，提高对减产风险的评估/模拟的精度和空间分辨率，并对数据集进行更新。当前存在的关键瓶颈仍是缺乏更高分辨率的单产数据集，以及质量可靠的保险赔案数据。在此，特别欢迎大家使用此套数据；同时也欢迎学界和业界的同仁为进一步丰富中国农业保险的基础费率区划成果共同努力和合作。\n" +
          "</p>\n" +
          "<p class=\"MsoNormal\" style=\"text-indent:21.0pt;\">\n" +
          "\t<span>使用数据时可引用：</span> \n" +
          "</p>\n" +
          "<p class=\"MsoListParagraph\" style=\"margin-left:39.0pt;text-indent:-18.0pt;\">\n" +
          "\t-&nbsp; 叶涛, 陈说, 刘苇航, 牟青洋, 史培军*, 张兴明. 全国主粮作物减产风险评估与保险费率厘定研究[J]. 保险研究, 2021(02): 3-16.\n" +
          "</p>\n" +
          "<p class=\"MsoNormal\" style=\"text-indent:21.0pt;\">\n" +
          "\t如有相关问题，请联系陈说（shuochen@mail.bnu.edu.cn)。\n" +
          "</p>\n" +
          "<p>\n" +
          "\t<br />\n" +
          "</p>\n" +
          "<p>\n" +
          "\t<br />\n" +
          "</p>",

        legends:[
        ]
      }
    },
    methods:{

      /**
       * 打开属性对话框
       * */
      openDescriptionDlg(){
        this.descriptionDlgVisible = true;
      },
      closeDescriptionDlg(){
        this.descriptionDlgVisible = false;
      },

      colorsChanged(colorGroups){
        this.selectedMapLegendsStyle = colorGroups;
        this.dynamicLodingWMSLayer(false);
      },

      updateStyle(){
        this.map.getLayers().forEach(function (layer) {
          const layer_name = layer.name;
          console.log("layer_name = ",layer_name);
          if(layer_name=="Temperature_Mean:cc_tmean_ann_mean_2000s_s0_value_mme_global"){
            console.log("layer finded");
            layer.getSource().updateParams({'STYLES': "Temperature_Mean_RT_MEAN"});
          }
        })
      },
      updateStyle_2(){
        this.map.getLayers().forEach(function (layer) {
          const layer_name = layer.name;
          console.log("layer_name = ",layer_name);
          if(layer_name=="Temperature_Mean:cc_tmean_ann_mean_2000s_s0_value_mme_global"){
            console.log("layer finded");
            layer.getSource().updateParams({'STYLES': "Temperature_Mean_RT_MEAN_V2"});
          }
        })
      },


      handleSelect(key, keyPath) {
        this.activeIndex = key;
        console.log("key = ",key,"&activeIndex =",this.activeIndex);
        if(key =="env")
        {
          this.mTabs = menus_env;
        }
        else if(key=="risk") {
          this.mTabs = menus_risk;
        }

        let rPath = "/BNUMap/"+key;
        this.$router.push({path:rPath})
      },

      menuClicked:function (item) {
        console.log("menu clicked = ",item);
      },

      //init the map container
      initMap:function () {
        this.map = this.$olMapUtils.init(
          {
            map:document.getElementById("map"),
            center:[112.828869,34.795014],
            initZoom:4.5,
            minZoom:4.5 ,
            geoserver:this.geoserver_local
          })
      },

      initLayout(){
        const screen_height = document.body.clientHeight;
        const page_header = 60;
        const content_height = screen_height -  page_header;
        document.getElementById("root_container").style.height = document.body.clientHeight+"px";
        document.getElementById("router_view").style.height = document.body.clientHeight - 60+"px";
        document.getElementById("map").style.height = document.body.clientHeight - 60+"px";
        document.getElementById("menu_container").style.height =content_height+"px";

        this.menu_width = document.getElementById("menu_container").clientWidth;
        //document.getElementById("climateMenu").style.width = this.menu_width+"px";
        document.getElementById("ChangeRisksMenus").style.width = this.menu_width+"px";
        this.content_height = document.body.clientHeight - 60;

        document.getElementById("mapResizeButton").style.top ="75px";
        document.getElementById("mapResizeButton").style.marginLeft ="3px";
      },

      mapResize(){
        if(this.menuSpan==3) {
          this.menuSpan = 0;
          this.mapSpan = 24;
          this.map.setSize(new toSize([document.body.clientWidth ,this.content_height]));
          this.menuResizeIcon = menuresizeicon_max;
        } else {
          this.menuSpan = 3;
          this.mapSpan = 21;
          this.map.setSize(new toSize([(document.body.clientWidth - this.menu_width),this.content_height]));
          this.menuResizeIcon = menuresizeicon_min;
        }
      },

      handleOpen(){},
      handleClose(){},

      //折叠菜单点击事件
      foldMenuClick(item)
      {
        let clickedMenuIndex= item.index;
        console.log("MenuClick Actijon &&  item.index = ", clickedMenuIndex);
        let menu_ary = clickedMenuIndex.split("_");
        this.lastClicedMenuItem = clickedMenuIndex;
        this.dynamicLodingWMSLayer(menu_ary[0],menu_ary[1],true);
      },

      //更新数据
      radioGroup_change()
      {
        //地图数据模型可见性控制住
        //this.cc_map_datamodel_visible();
        //Raster Layer
        this.dynamicLodingWMSLayer();
      },

      // {radio_title:"栅格",radio_code:"raster"},{radio_title:"地市",radio_code:"city"},{radio_title:"县级",radio_code:"county"}
      //动态加载图层
      dynamicLodingWMSLayer(crops,crops_rate,needUpdateLegends=true){

        if(crops==undefined){
          let menu_ary = this.lastClicedMenuItem.split("_");
          crops = menu_ary[0];
          crops_rate = menu_ary[1];
        }

        console.log("dynamicLodingWMSLayer = ",crops," && this.radioG_cc_prcptot_mm = ",this.radioG_cc_prcptot_mm);
        if(this.defaultMapOverlay){
          this.defaultMapOverlay.setPosition(undefined);
        }

        //移除旧涂层
        let datas = ["1","2","3","4"];
        datas.forEach(item=>{
          let layers = this.map.getLayers();
          let layer_lenght = layers.getLength();
          let rasterLayer = undefined;
          for(let i=0;i<layer_lenght;i++){
            const item_layer = layers.item(i);
            const layer_olTag = item_layer.olTag;
            if(layer_olTag && layer_olTag=="cropRisk"){
              rasterLayer = item_layer;
              break;
            }
          }
          this.map.removeLayer(rasterLayer);
        })


        let wms_ws = undefined;
        let layerCode = undefined;
        if(this.radioG_cc_prcptot_mm=="fxfl") {        //风险费率
          wms_ws = "catastrophic_risk_premium_rate";
          layerCode = crops + "_mme_1981_2016_lcr_" + crops_rate + "_return_" + this.radioG_10_20;
          layerCode = wms_ws + ":" + layerCode;
        }else if(this.radioG_cc_prcptot_mm=="cfxssl"){ //纯风险损失率
          console.log("纯风险损失率 && this.radioG_cc_prcpto = ",this.radioG_cc_prcptot);
          if(this.radioG_cc_prcptot=="raster"){
            wms_ws = "fair_premium_rate";
            layerCode = crops + "_mme_1981_2016_lcr_" + crops_rate;
            layerCode = wms_ws + ":" + layerCode;

          }
          else if(this.radioG_cc_prcptot=="city"){
            wms_ws = "BSD";
            layerCode = "city_maize_wheat_rice_mme_1981_2016_lcr_"+crops_rate;
            layerCode = wms_ws + ":" + layerCode;
            let layerStyles = "city_mme_1981_2016_lcr_"+crops_rate+"_"+crops;

            console.log("map source = county && layerCode = ",layerCode," && layerStyles = ",layerStyles);
            this.selectedRasterMapLayer = this.$olMapUtils.addWMSLayer({
              layerName:layerCode,
              layerCode:layerCode,
              visible:true,
              geoServer:tifflayer_accessurl,zIndex:10,olTag:"cropRisk",styles:layerStyles});
            //属于Shp数据源 && olSourceType
            this.selectedRasterMapLayer.olSourceType = "shp";
            this.selectedRasterMapSrouce = layerCode;

            //
            this.updateMapLengends();
            return;
          }
          else if(this.radioG_cc_prcptot="county"){

            wms_ws = "BSD";
            layerCode = "county_maize_wheat_rice_mme_1981_2016_lcr_"+crops_rate;
            let layerStyles = layerCode+"_"+crops;
            layerCode = wms_ws + ":" + layerCode;

            console.log("map source = county && layerCode = ",layerCode," && layerStyles = ",layerStyles);
            this.selectedRasterMapLayer = this.$olMapUtils.addWMSLayer({
              layerName:layerCode,
              layerCode:layerCode,
              visible:true,
              geoServer:tifflayer_accessurl,zIndex:10,olTag:"cropRisk",styles:layerStyles});
            //属于Shp数据源 && olSourceType
            this.selectedRasterMapLayer.olSourceType = "shp";
            this.selectedRasterMapSrouce = layerCode;

            this.updateMapLengends();
            return;
          }

        }
        console.log("layerCode = ",layerCode," && wms_ws= ",wms_ws);

        //拼接工作空间
        wms_ws = wms_ws.toLowerCase();
        let tifflayer_accessurl = this.readGeoTiffAccessUrl(wms_ws);

        if(needUpdateLegends){
          this.updateMapLengends();
        }
        console.log("dynamicLodingWMSLayer && needUpdateLegends = ",needUpdateLegends);

        //此处采用：： intervals 的方式
        let styleData= this.$olMapUtils.colorGroupReverse_NODATA_BLACK(this.selectedMapLegendsStyle);
        let layerSytleColorGroups =this.$olMapUtils.parseSLDBodyWithType(this.$x2js,layerCode, styleData,"RAMP");//intervals

        //更新图例数据
        this.selectedRasterMapWS = tifflayer_accessurl;
        this.selectedRasterMapSrouce = layerCode;
        this.selectedRasterMapLayer = this.$olMapUtils.addWMSLayer({
          defaultStyles:layerSytleColorGroups,
          layerName:layerCode,
          layerCode:layerCode,
          visible:true,
          geoServer:tifflayer_accessurl,zIndex:10,olTag:"cropRisk"});

        //
        this.updateMapLegendTitle();
      },

      //更新地图图例
      updateMapLegendTitle(){
        let current_layer_code = this.selectedRasterMapSrouce.replace(":","_").toUpperCase();
        let title = BSDConfigLegendTitle[current_layer_code];
        if(title==undefined){
          current_layer_code = current_layer_code.replace("GLOBAL","GOBAL").toUpperCase();
          title = BSDConfigLegendTitle[current_layer_code];
        }
        this.legendTitle =title;
      },

      //地图数据模式加载 - Change & Value
      cc_map_datamodel_visible(){
        let selected_cascader_laster = this.selected_cascader[this.selected_cascader.length-1];
        if(selected_cascader_laster=="2000_s0" || selected_cascader_laster=="2000s_s0"){
          return false;
        }
        return true;
      },



      /**
       * Annual && Winter && Summer 配置参数更新
       * */
      radioG_MapTime_updateConfig(){
        let selectedRadioGroupData =  Risk_radioGroupData[this.lastClicedMenuItem];
        if(selectedRadioGroupData!=undefined && selectedRadioGroupData.length>0) {
          console.log("radioG_MapTime_updateConfig::lastClicedMenuItem = ",this.lastClicedMenuItem," && HAS DATA");
          this.radioData = selectedRadioGroupData;
          let selectedRadioGroupData_default = selectedRadioGroupData[0];
          this.radioG_cc_prcptot = selectedRadioGroupData_default.radio_code;
        }else {
          console.log("radioG_MapTime_updateConfig::lastClicedMenuItem = ",this.lastClicedMenuItem," && HAS NO DATA");
        }
      },

      /**
       *
       **/
      readGeoTiffAccessUrl(workspace){
        return this.geoserver_basic+workspace+"/wms";
      },


      /**
       * Resize Map Container
       * */
      mapSourceLayout(){

      },

      /**
       * 根据路由路径打开默认的地图图层
       * */
      openDefaultMapSource(){
        let routerPath = this.$route.path;
        let pathAry = routerPath.split("\/");
        let last_router_path = pathAry[pathAry.length-1];
        if(last_router_path=="cropsRisk") {
          this.$refs.el_menu_risk.open('cropRisk_RICE'); //默认打开一个菜单
          //默认加载一个地图图层
          this.foldMenuClick({
            index:"rice_100",
            $attrs:{
              menuGroup:"cc_temprature"
            }
          })
        }
      },


      legend_layoutupdate(data){
        // let obj = document.getElementById("IDLegend");
        // let obj_height = obj.style.height;
      },

      legend_layoutupdate_show(){
        // let obj = document.getElementById("IDLegend");
        // obj.style.bottom = "0px";
        // document.getElementById("IDLegend").style.display = 'block';
        // this.$refs.ref_mapLegend.updateHeight_cropsRisk();
        // console.log("this.selectedMapLegendsStyle = ",this.selectedMapLegendsStyle);


        this.legends = this.selectedMapLegendsStyle;
        let title_height = 25;
        let legend_height = this.selectedMapLegendsStyle.length * 25 +title_height;
        document.getElementById("mapLegends").style.height  = legend_height + "px";
        document.getElementById("mapLegends").style.bottom  = "0px";
      },

      /**
       * 矢量英文注记
       * */
      addTDM_LAYER_EVA_C(){

        let  selectedLayer = undefined;
        const layers = this.map.getLayers();
        const layer_lenght = layers.getLength();

        for(let i=0;i<layer_lenght;i++){
          const item = layers.item(i);
          const item_name = item.name;
          //console.log("index = ",i," &layer = ",item,"&item_name = ",item_name);
          if(item_name!=undefined && item_name=="BSD:TDM_LAYER_EVA_C") {
            selectedLayer = item;
          }
        }

        if(selectedLayer==undefined){
         //console.log("add new  TDM_LAYER_EVA_C");
          TDM_LAYER_EVA_C.setZIndex(500);
          this.map.addLayer(TDM_LAYER_EVA_C);
        }
      },




      /**
       * 查询地图点击查询值
       * */
      readMapPoint(evt){
        //Remove the map overlay
        this.defaultMapOverlay.setPosition(undefined);
        //校验点是否有效
        let view = this.map.getView();
        let viewResolution = view.getResolution();
        let source =this.basicOceanLayer.getSource();
        let url = source.getFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          view.getProjection(),
          {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});
        let _this = this;
        this.axios.get(url).then((response)=>{
          //console.log("checkQueryPointValid::response.data = ",response.data);
          const selectedFeatures =response.data.features;
          //只有点击非海洋范围的图层才能进行下一步的栅格查询
          if(selectedFeatures.length==0){
            //单数据查询
            _this.readSelectedPointData(evt);
          }
        })
      },

      /**
       * @description - 查询栅格图层单击点值 - 2021年1月22日17:47:39
       * */
      readSelectedPointData(evt){
        var view = this.map.getView();
        var viewResolution = view.getResolution();
        var source =this.selectedRasterMapLayer.getSource();
        console.log("readSelectedPointData &&this.selectedRasterMapLayer = ",this.selectedRasterMapLayer);
        let olSourceType = this.selectedRasterMapLayer.olSourceType;
        var url = source.getFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          view.getProjection(),
          {'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 50});

        let _this = this;

        console.log("readSelectedPointData::url = ",url);
        this.axios.get(url).then((response)=>{
          console.log("response.data = ",response.data);
          const selectedFeatures =response.data.features;
          if(selectedFeatures.length>0) {
            const selectedFeature = selectedFeatures[0];
            const selectedFeature_properties = selectedFeature.properties;
            if(olSourceType&& olSourceType=="shp"){
              let crops = _this.lastClicedMenuItem.split("_")[0];
              console.log("olSourcetype = shp && this.crops = ",crops);
              let rasterData = selectedFeature_properties[crops];
              if(parseInt(rasterData)==-999){
                console.log("NO DATA && NO NOTHING");
                return
              }
              _this.selectedRasterMapData = selectedFeature_properties[crops];
            } else {
              _this.selectedRasterMapData = selectedFeature_properties.GRAY_INDEX;
            }

            console.log("this.selectedRasterMapData = ",this.selectedRasterMapData);
            if((_this.selectedRasterMapData && _this.selectedRasterMapData !=null) || parseFloat(this.selectedRasterMapData)==0){
              _this.defaultMapOverlay.setPosition(evt.coordinate);
            } else {
              _this.defaultMapOverlay.setPosition(undefined);
            }

          }
        })
      },

      initMapOverlay(){
        if(this.map && this.defaultMapOverlay==undefined){
          var container = document.getElementById('popup');
          var closer = document.getElementById('popup-closer');
          var overlay = new Overlay({
            element: container,
            autoPan: true,
            autoPanAnimation: {
              duration: 250,
            },
          });
          closer.onclick = function () {
            overlay.setPosition(undefined);
            closer.blur();
            return false;
          };
          this.map.addOverlay(overlay);
          this.defaultMapOverlay = overlay;
        }
      },


      /**
       * 样式文件更新 Update time is 2020年12月9日13:07:58
       * */
      updateMapLengends(){
        console.log("updateMapLengends:: && this.lastClicedMenuItem = ", this.lastClicedMenuItem);
        let crops_ids = this.lastClicedMenuItem.split("_");
        let selected_crop = crops_ids[0].toLowerCase();
        let selected_crop_riskRate = crops_ids[1].toLowerCase();
        let selectedSLDFile = undefined;
        if(this.radioG_cc_prcptot_mm=="fxfl") {
          //风险费率
          if (selected_crop == "rice") {
            selectedSLDFile = catastrophic_rice;
            this.currentStyle = "catastrophic_rice";
          } else if (selected_crop == "wheat") {
            selectedSLDFile = catastrophic_wheat;
            this.currentStyle = "catastrophic_wheat";
          } else if (selected_crop == "maize") {
            selectedSLDFile = catastrophic_maize;
            this.currentStyle = "catastrophic_maize";
          }
          //
          let styletitle = selected_crop+"_MME_1981_2016_lcr_"+selected_crop_riskRate+"_return_"+this.radioG_10_20;
          switch (styletitle){
            case "maize_MME_1981_2016_lcr_70_return_10":
              selectedSLDFile = maize_MME_1981_2016_lcr_70_return_10;
              this.currentStyle = "maize_MME_1981_2016_lcr_70_return_10";
              break;
            case "maize_MME_1981_2016_lcr_70_return_20":
              selectedSLDFile = maize_MME_1981_2016_lcr_70_return_20;
              break;
            case "maize_MME_1981_2016_lcr_80_return_10":
              selectedSLDFile = maize_MME_1981_2016_lcr_80_return_10;
              break;
            case "maize_MME_1981_2016_lcr_80_return_20":
              selectedSLDFile = maize_MME_1981_2016_lcr_80_return_20;
              break;
            case "maize_MME_1981_2016_lcr_90_return_10":
              selectedSLDFile = maize_MME_1981_2016_lcr_90_return_10;
              break;
            case "maize_MME_1981_2016_lcr_90_return_20":
              selectedSLDFile = maize_MME_1981_2016_lcr_90_return_20;
              break;
            case "maize_MME_1981_2016_lcr_100_return_10":
              selectedSLDFile = maize_MME_1981_2016_lcr_100_return_10;
              break;
            case "maize_MME_1981_2016_lcr_100_return_20":
              selectedSLDFile = maize_MME_1981_2016_lcr_100_return_20;
              break;
            case "rice_MME_1981_2016_lcr_70_return_10":
              selectedSLDFile = rice_MME_1981_2016_lcr_70_return_10;
              break;
            case "rice_MME_1981_2016_lcr_70_return_20":
              selectedSLDFile = rice_MME_1981_2016_lcr_70_return_20;
              break;
            case "rice_MME_1981_2016_lcr_80_return_10":
              selectedSLDFile = rice_MME_1981_2016_lcr_80_return_10;
              break;
            case "rice_MME_1981_2016_lcr_80_return_20":
              selectedSLDFile = rice_MME_1981_2016_lcr_80_return_20;
              break;
            case "rice_MME_1981_2016_lcr_90_return_10":
              selectedSLDFile = rice_MME_1981_2016_lcr_90_return_10;
              break;
            case "rice_MME_1981_2016_lcr_90_return_20":
              selectedSLDFile = rice_MME_1981_2016_lcr_90_return_20;
              break;
            case "rice_MME_1981_2016_lcr_100_return_10":
              selectedSLDFile = rice_MME_1981_2016_lcr_100_return_10;
              break;
            case "rice_MME_1981_2016_lcr_100_return_20":
              selectedSLDFile = rice_MME_1981_2016_lcr_100_return_20;
              break;
            case "wheat_MME_1981_2016_lcr_70_return_10":
              selectedSLDFile = wheat_MME_1981_2016_lcr_70_return_10;
              break;
            case "wheat_MME_1981_2016_lcr_70_return_20":
              selectedSLDFile = wheat_MME_1981_2016_lcr_70_return_20;
              break;
            case "wheat_MME_1981_2016_lcr_80_return_10":
              selectedSLDFile = wheat_MME_1981_2016_lcr_80_return_10;
              break;
            case "wheat_MME_1981_2016_lcr_80_return_20":
              selectedSLDFile = wheat_MME_1981_2016_lcr_80_return_20;
              break;
            case "wheat_MME_1981_2016_lcr_90_return_10":
              selectedSLDFile = wheat_MME_1981_2016_lcr_90_return_10;
              break;
            case "wheat_MME_1981_2016_lcr_90_return_20":
              selectedSLDFile = wheat_MME_1981_2016_lcr_90_return_20;
              break;
            case "wheat_MME_1981_2016_lcr_100_return_10":
              selectedSLDFile = wheat_MME_1981_2016_lcr_100_return_10;
              break;
            case "wheat_MME_1981_2016_lcr_100_return_20":
              selectedSLDFile = wheat_MME_1981_2016_lcr_100_return_20;
              break;
          }


        }else {
          //cfxssl
          selectedSLDFile = catastrophic_rice;
          this.currentStyle = "catastrophic_rice";
          let clicedMenus = this.lastClicedMenuItem.split("_");
          let coverRate = clicedMenus[1];
          let coverCrop = clicedMenus[0];

          if(this.radioG_cc_prcptot=="raster"){
            let styletitle = coverCrop+"_MME_1981_2016_lcr_"+coverRate;
            switch (styletitle){
              case "maize_MME_1981_2016_lcr_100":
                selectedSLDFile = maize_MME_1981_2016_lcr_100;
                break;
              case "maize_MME_1981_2016_lcr_90":
                selectedSLDFile = maize_MME_1981_2016_lcr_90;
                break;
              case "maize_MME_1981_2016_lcr_80":
                selectedSLDFile = maize_MME_1981_2016_lcr_80;
                break;
              case "maize_MME_1981_2016_lcr_70":
                selectedSLDFile = maize_MME_1981_2016_lcr_70;
                break;
              case "rice_MME_1981_2016_lcr_100":
                selectedSLDFile = rice_MME_1981_2016_lcr_100;
                break;
              case "rice_MME_1981_2016_lcr_90":
                selectedSLDFile = rice_MME_1981_2016_lcr_90;
                break;
              case "rice_MME_1981_2016_lcr_80":
                selectedSLDFile = rice_MME_1981_2016_lcr_80;
                break;
              case "rice_MME_1981_2016_lcr_70":
                selectedSLDFile = rice_MME_1981_2016_lcr_70;
                break;
              case "wheat_MME_1981_2016_lcr_100":
                selectedSLDFile = wheat_MME_1981_2016_lcr_100;
                break;
              case "wheat_MME_1981_2016_lcr_90":
                selectedSLDFile = wheat_MME_1981_2016_lcr_90;
                break;
              case "wheat_MME_1981_2016_lcr_80":
                selectedSLDFile = wheat_MME_1981_2016_lcr_80;
                break;
              case "wheat_MME_1981_2016_lcr_70":
                selectedSLDFile = wheat_MME_1981_2016_lcr_70;
                break;
            }
          }else if(this.radioG_cc_prcptot=="city"){
            let styletitle = "city_mme_1981_2016_lcr_"+coverRate+"_"+coverCrop;
            switch (styletitle) {
              case "city_mme_1981_2016_lcr_100_maize":
                selectedSLDFile = city_mme_1981_2016_lcr_100_maize;
                break;
              case "city_mme_1981_2016_lcr_100_rice":
                selectedSLDFile = city_mme_1981_2016_lcr_100_rice;
                break;
              case "city_mme_1981_2016_lcr_100_wheat":
                selectedSLDFile = city_mme_1981_2016_lcr_100_wheat;
                break;
              case "city_mme_1981_2016_lcr_70_maize":
                selectedSLDFile = city_mme_1981_2016_lcr_70_maize;
                break;
              case "city_mme_1981_2016_lcr_70_rice":
                selectedSLDFile = city_mme_1981_2016_lcr_70_rice;
                break;
              case "city_mme_1981_2016_lcr_70_wheat":
                selectedSLDFile = city_mme_1981_2016_lcr_70_wheat;
                break;
              case "city_mme_1981_2016_lcr_80_maize":
                selectedSLDFile = 	city_mme_1981_2016_lcr_80_maize;
                break;
              case "city_mme_1981_2016_lcr_80_rice":
                selectedSLDFile = city_mme_1981_2016_lcr_80_rice;
                break;
              case "city_mme_1981_2016_lcr_80_wheat":
                selectedSLDFile = 	city_mme_1981_2016_lcr_80_wheat;
                break;
              case "city_mme_1981_2016_lcr_90_maize":
                selectedSLDFile = city_mme_1981_2016_lcr_90_maize;
                break;
              case "city_mme_1981_2016_lcr_90_rice":
                selectedSLDFile = city_mme_1981_2016_lcr_90_rice;
                break;
              case "city_mme_1981_2016_lcr_90_wheat":
                selectedSLDFile = city_mme_1981_2016_lcr_90_wheat;
                break;
            }
          }else if(this.radioG_cc_prcptot=="county"){
            let styletitle = "county_maize_wheat_rice_mme_1981_2016_lcr_"+coverRate+"_"+coverCrop;
            switch (styletitle){
              case "county_maize_wheat_rice_mme_1981_2016_lcr_100_maize":
                selectedSLDFile = county_maize_wheat_rice_mme_1981_2016_lcr_100_maize;
                break;
              case "county_maize_wheat_rice_mme_1981_2016_lcr_100_rice":
                selectedSLDFile = county_maize_wheat_rice_mme_1981_2016_lcr_100_rice;
                break;
              case "county_maize_wheat_rice_mme_1981_2016_lcr_100_wheat":
                selectedSLDFile = county_maize_wheat_rice_mme_1981_2016_lcr_100_wheat;
                break;
              case "county_maize_wheat_rice_mme_1981_2016_lcr_90_maize":
                selectedSLDFile = county_maize_wheat_rice_mme_1981_2016_lcr_90_maize;
                break;
              case "county_maize_wheat_rice_mme_1981_2016_lcr_90_rice":
                selectedSLDFile = county_maize_wheat_rice_mme_1981_2016_lcr_90_rice;
                break;
              case "county_maize_wheat_rice_mme_1981_2016_lcr_90_wheat":
                selectedSLDFile = county_maize_wheat_rice_mme_1981_2016_lcr_90_wheat;
                break;
              case "county_maize_wheat_rice_mme_1981_2016_lcr_80_maize":
                selectedSLDFile = county_maize_wheat_rice_mme_1981_2016_lcr_80_maize;
                break;
              case "county_maize_wheat_rice_mme_1981_2016_lcr_80_rice":
                selectedSLDFile = county_maize_wheat_rice_mme_1981_2016_lcr_80_rice;
                break;
              case "county_maize_wheat_rice_mme_1981_2016_lcr_80_wheat":
                selectedSLDFile = county_maize_wheat_rice_mme_1981_2016_lcr_80_wheat;
                break;
              case "county_maize_wheat_rice_mme_1981_2016_lcr_70_maize":
                selectedSLDFile = county_maize_wheat_rice_mme_1981_2016_lcr_70_maize;
                break;
              case "county_maize_wheat_rice_mme_1981_2016_lcr_70_rice":
                selectedSLDFile = county_maize_wheat_rice_mme_1981_2016_lcr_70_rice;
                break;
              case "county_maize_wheat_rice_mme_1981_2016_lcr_70_wheat":
                selectedSLDFile = county_maize_wheat_rice_mme_1981_2016_lcr_70_wheat;
                break;
            }
          }
        }

        if(selectedSLDFile){
          let legendsData_reverse = [];
          let legendsDataAry= selectedSLDFile["sld:ColorMapEntry"];

          for(let i=legendsDataAry.length-1;i>=0;i--){
            let item = legendsDataAry[i];
            //item.quantity = parseFloat(item.quantity)*0.01;

            if(i==(legendsDataAry.length-1)){
              //最后一个最大值执行处理 |2021年1月17日11:28:04
              // let quantity = parseInt(item.quantity) + "0000";
              // item.quantity = parseInt(quantity);
            }
            legendsData_reverse.push(item);
          }
          //注释于2020年12月14日21:55:57
          //this.selectedMapLegendsStyle = legendsData_reverse;
          //legendsData_reverse.push(  {"quantity":-10000,"color":"#FF00FF","label":"mv"});
          //深度拷贝更新于 2020年12月14日15:45:21
          this.selectedMapLegendsStyle = JSON.parse(JSON.stringify(legendsData_reverse));
        }else{
          this.selectedMapLegendsStyle = undefined;
          alert("The Style File of The Layer Can Not Find!");
        }

        console.log("selectedSLDFile = ",selectedSLDFile);
        //this.$refs.ref_mapLegend.updateHeight_cropsRisk();
        this.legend_layoutupdate_show();
      },
    },

    mounted() {
      this.initLayout();
      this.initMap();

      //底图
      this.basicOceanLayer = this.$olMapUtils.addWMSLayer({layerName:"BSD:ocean", layerCode:"BSD:ocean", visible:true,});
      //this.basicOceanLayer.olTag = "boundary_country";

      let _this = this;
      this.map.on('click', function (event) {
        var coordinate = event.coordinate;
        var _map = event.target;
        var pixel =_map.getPixelFromCoordinate(coordinate);
        if(_this.selectedRasterMapLayer){
          _this.readMapPoint(event);
        }
      });

      const lon_min = 73.295953;
      const lon_max = 136.141119;
      const lat_min = 0.065647;
      const lat_max = 54.61892;
      this.map.on('moveend',function (event){

        _this.mapZoomLevel = _this.map.getView().getZoom();
        if(_this.mapZoomLevel>6.5){
          //_this.mapboundaryLayer.setVisible(false);
          _this.$olMapUtils.setLayerVisibleWithOlTag("boundary_country",false);
          _this.$olMapUtils.setLayerVisibleWithOlTag("boundary_province",true);

        }else{
          _this.$olMapUtils.setLayerVisibleWithOlTag("boundary_country",true);
          _this.$olMapUtils.setLayerVisibleWithOlTag("boundary_province",false);
        }



        let mCenter = _this.map.getView().getCenter();
        let lon = mCenter[0];
        let lat = mCenter[1];
        if(lon<lon_min){
          mCenter[0] = lon_min;
          mCenter = [105.564811,32.767271];
          _this.map.getView().setCenter(mCenter);
        }
        if(lon>lon_max){
          mCenter[0] = lon_max;
          mCenter = [105.564811,32.767271];
          _this.map.getView().setCenter(mCenter);
        }

        if(lat<lat_min){
          mCenter[1] = lat_min;
          mCenter = [105.564811,32.767271];
          _this.map.getView().setCenter(mCenter);
        }

        if(lat>lat_max){
          mCenter[1] = lat_max;
          mCenter = [105.564811,32.767271];
          _this.map.getView().setCenter(mCenter);
        }
      });


      //
      this.radioG_MapTime_updateConfig();
      //
      this.$watch('selectedRasterMapSrouce', function (newValue, oldValue) {//a是属性名，表示要监听的对象
        this.mapSourceLayout();
      });
      this.mapSourceLayout();
      //加载默认地图渲染图层
      this.openDefaultMapSource();
      //
      this.initMapOverlay();
      //
      //this.legend_layoutupdate_show();
      this.loginUser = this.$appStorage.getUserMailbox();


      this.menuSpan=0;
      this.mapResize();

      this.legendModel = 0;
      this.legend_layoutupdate_show();
      // setTimeout(function (){
      //   if(_this.legendModel==1){
      //     _this.$refs.ref_mapLegend.updateHeight_cropsRisk();
      //   }
      // },50);

      //国家边界 -天地图
      TDM_LAYER_IBO_C.setZIndex(21);
      this.map.addLayer(TDM_LAYER_IBO_C);
      //TDM_LAYER_IBO_C.olTag ="boundary_country";

      TDM_LAYER_CVA_C.setZIndex(30);
      this.map.addLayer(TDM_LAYER_CVA_C);
      TDM_LAYER_CVA_C.setVisible(true);


      //添加国家边界 - geojson
     let chinaBorder = new VectorLayer({
        source: new VectorSource({
          features:new GeoJSON().readFeatures(geojsonData_China)
        }),
        style:new Style({
          stroke: new Stroke({ //边界样式
            color: '#319FD3',
            width: 1.5
          })
        })
      });
      chinaBorder.olTag ="boundary_country";
      this.mapboundaryLayer = chinaBorder;
      this.mapboundaryLayer.setVisible(true)
      chinaBorder.setZIndex(22);
      this.map.addLayer(chinaBorder);


      //添加省级边界
      // let provincesBoundarys = [GJ_Henan,GJ_Hebei,GJ_Shangdong,GJ_Xinjiang,
      // neimengdu,beijingshi,jilinsheng,sichuansheng,tianjinshi,anhui,guangdong,guangxi,liaoning,helongjiang,
      // xizang,qinghai,shanxi,shanxii,gansu,ningxia,hubei,hunan,chongqing,guizhou,jiangxi,zhejiang,jiangsu,
      //   yunan,fujian,shanghai];
      // for(let i=0;i<provincesBoundarys.length;i++){
      //   let item = provincesBoundarys[i];
      //   let item_layer = new VectorLayer({
      //     source: new VectorSource({
      //       features:new GeoJSON().readFeatures(item)
      //     }),
      //     style:new Style({
      //       stroke: new Stroke({ //边界样式
      //         color: '#808080',
      //         width: 0.5
      //       })
      //     })
      //   });
      //   item_layer.olTag = "boundary_province";
      //   item_layer.setZIndex(24);
      //   item_layer.setVisible(false);
      //   this.map.addLayer(item_layer);
      // };


      document.getElementsByClassName("ol-zoom").style.width = "100px";
    }
  }
</script>




<style scoped lang="scss">
.BSD_TITLE{
  margin-top: 5px;
  height: 30px;
  line-height: 30px;
  font-size: 20px;
  text-align: left;
}
.BSD_SUBTITLE{
  height: 20px;
  line-height: 20px;
  font-size: 18px;
  text-align: left;
}

.GS_menuItem
{
  font-size: 18px;
}

.subMenu
{
  font-size: 15px;
}


.GS_HeaderItem{
  font-size: 16px;
}

.elMenuItem{
  padding-left:10px;
  padding-right:10px;
}

.GS_SHIDUAN
{
  width: 200px;
}


.el-menu-demo
{
  width: auto;
  text-align: right;
  right: 80px;
  position: absolute;
}

#router_view{
  padding: 0px;margin: 0px; overflow: hidden; z-index: 1;background-color: transparent
}

#menu_container{
  border-right: solid 2px lightgrey; height: 100%;
}

#mapResizeButton{
  width: 30px;
  height: 40px;
  background-color: transparent;
  position: absolute;
  float: left;
  left: 0px;
  bottom: 10px;
  z-index: 100
}

.headerManu
{
  padding: 0px;margin: 0px; overflow: hidden;background-color: #545c64; z-index: 2; height: 60px;
}

.menuGroup_title
{
  background-color: transparent;text-align: left;
}

.css_map_footer{
  width: 100%;
  height: 40px;
  position: absolute;
  bottom: 0px;
  z-index: 5;
  border-top: solid 1px lightgrey;
  .bg{
    position: absolute;
    width: 100%;
    height: 40px;
    background-color: black;
    opacity: 0.4;
    z-index: 0;
  }
  .context{
    position: absolute;
    width: 100%;
    height: 40px;
    background-color: transparent;
    z-index: 1;
    line-height: 40px;
    font-size: 17px;
    color: white;
  }
}

.legend{
  z-index: 2;
  background-color: transparent;
  position: absolute;
  right:0px;
}

.radio_group{
  position:absolute;
  top: 10px;
  left: 50px;
  width: auto;
  display: flex;
  flex-direction: row;


  .item_one{
    background-color: white;
    border: 1px solid lightgrey;
    padding: 11px 20px;
    border-radius: 4px;
  }
  .item_more{
    background-color: white;
    border: 1px solid lightgrey;
    padding: 11px 20px;
    border-radius: 4px;
    margin-left: 15px;
  }
}



.css_cascader{
  position:absolute;
  top: 10px;
  right: 5px;
  width: 180px;
  display: flex;
  flex-direction: row;
  background-color: white;
  padding: 0px;
  height: 40px;
  border-radius: 4px;
}







.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
  padding: 15px;
  border-radius: 5px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 70px;
  font-size: 17px;
}
.ol-popup:after, .ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.ol-popup-closer {
  color: red;
  font-size: 14px;
}
.ol-popup-closer:after {
  content: "✖";
}


.css_cascader{
  width: 200px;
}


.pdf-el-dialog .pdf-dialog {
  width: 100%;
  height: 70vh;
  background-color: transparent;
  overflow-y: scroll;
}
.pdf-el-dialog .pdf-dialog .el-dialog__body {
  padding-bottom: 0px;
}

/* 跳转到外面 */
.pdf-el-dialog .icon-analysis {
  font-size: 18px;
  position: relative;
  margin-right: 35px;
  float: right;
  margin-top: -40px;
  cursor: pointer;
}
.pdf-el-dialog .icon-analysis:hover{
  color: red;
}




/*图例*/
.cell_tile{
  width: 50px;
  height: 18px;
  margin-top: 3px;
  margin-right: 5px;
  border: 1px solid lightgrey;
  border-radius: 3px;
}
.cell_col_0
{
  text-align: left;
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}


#map .ol-zoom .ol-zoom-out {
  margin-top: 204px;
}
#map .ol-zoomslider {
  background-color: transparent;
  top: 2.3em;
}
#map .ol-zoom-extent {
  top: 280px;
}



</style>



// WEBPACK FOOTER //
// src/view/BSD/BNUCropsRisk.vue